import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
  WebGalleryStoreProvider,
  WindowSizeContextProvider,
  LanguageContextProvider,
} from "../hooks";
import WebGalleryError from "./routes/web-gallery-error/WebGalleryError";
import WebGallery from "./routes/web-gallery/WebGallery";
import WebDetail from "./routes/web-detail/WebDetail";
import Authorize from "./routes/Authorize";

export interface IWebGalleryUrlParams {
  galleryId: string;
  assetId: string;
}

const App = (props: { config: MediaValetConfiguration }) => {
  return (
    <WebGalleryStoreProvider config={props.config}>
      <WindowSizeContextProvider>
        <LanguageContextProvider>
          <Router basename="/galleries">
            <Switch>
              <Route
                exact
                path="/:galleryId-ExternalUser/authorize"
                component={Authorize}
              />
              <Route
                exact
                path="/:galleryId-ExternalUser"
                component={WebGallery}
              />
              <Route
                exact
                path="/:galleryId-ExternalUser/:assetId/authorize"
                component={Authorize}
              />
              <Route
                exact
                path="/:galleryId-ExternalUser/:assetId"
                component={WebDetail}
              />
              <Route path="*" component={WebGalleryError} />
            </Switch>
          </Router>
        </LanguageContextProvider>
      </WindowSizeContextProvider>
    </WebGalleryStoreProvider>
  );
};

export default App;